import { defineStore } from 'pinia'

import VoiceBankRepository from '@/app/repositories/voice-bank-repository'
import VoiceBankLanguagesRepository from '@/app/repositories/voice-bank-languages-repository'
import VoiceBankTypesRepository from '@/app/repositories/voice-bank-types-repository'
import type { VoiceBankEntry } from '@/common/models/data/dashboard/voice-bank/voice-bank-entry'
import type { VoiceBankLanguage } from '@/common/models/data/dashboard/voice-bank/voice-bank-language'
import type { VoiceBankType } from '@/common/models/data/dashboard/voice-bank/voice-bank-type'

const useVoiceBankStore = defineStore('voiceBank', {
    state: () => ({
        entries: [] as Array<VoiceBankEntry>,
        languages: [] as Array<VoiceBankLanguage>,
        types: [] as Array<VoiceBankType>
    }),
    actions: {
        async load (): Promise<void> {
            const [entries, languages, types] = await Promise.all([
                VoiceBankRepository.all(),
                VoiceBankLanguagesRepository.all(),
                VoiceBankTypesRepository.all()
            ])

            this.entries = entries
            this.languages = languages
            this.types = types
        }
    },
    getters: {
        filteredEntries: (state) => {
            return (sex: Array<boolean>, type: Array<number>, lang: Array<number>): Array<VoiceBankEntry> => {
                return state.entries.filter(entry => {
                    return sex.includes(entry.female)
                        && type.includes(entry.type.id)
                        && lang.includes(entry.language.id)
                })
            }
        }
    }
})

export {
    useVoiceBankStore
}
